/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

const commonConfig = {
  baseURL: process.env.REACT_APP_API_HOST,
  timeout: process.env.REACT_APP_REQUEST_TIMEOUT || 10000,
};

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('[Axios Request Error] Data:', error.response.data);
      console.error('[Axios Request Error] Status:', error.response.status);
      console.error('[Axios Request Error] Headers:', error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.error('[Axios Request Error] Request:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('[Axios Request Error] Message:', error.message);
    }
    console.error(error.config);
    return Promise.reject(error);
  }
);

export const publicNetwork = axios.create({
  ...commonConfig,
});

const privateNetwork = axios.create({
  ...commonConfig,
});

// Request interceptor for API calls
privateNetwork.interceptors.request.use(
  async (config) => {
    const accessToken = sessionStorage.getItem('geobahia_access_token');
    config.headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
// TODO RefreshToken
// TODO Observar uso em https://thedutchlab.com/blog/using-axios-interceptors-for-refreshing-your-api-token

export const auth = async (username, password) => {
  return publicNetwork.post(
    '/oauth',
    {
      username,
      password,
      grant_type: 'password',
    },
    {
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_GEOBAHIA_CLIENT_KEY}`,
      },
    }
  );
};

export const authorization = async (username, password) => {
  return publicNetwork.get('/autorizacao', {
    params: {
      username,
      password,
    },
  });
};

export const recoveryPassword = async (email) => {
  return publicNetwork.post(
    '/recuperacao-senha',
    {
      email,
    },
  );
};

export const getRefreshToken = async () => {
  const refreshToken = sessionStorage.getItem('geobahia_refresh_token');
  return publicNetwork.post(
    '/oauth',
    {
      refresh_token: refreshToken,
      grant_type: 'refresh_token',
    },
    {
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_GEOBAHIA_CLIENT_KEY}`,
      },
    }
  );
};

export default privateNetwork;
